// extracted by mini-css-extract-plugin
export default {"innerWrapper":"ou-z","tooltipWrapper":"pu-z","icon":"qu-z","tooltip":"ru-z","content":"su-z"};